/* eslint-disable indent */
/* eslint-disable no-unused-vars */
/* eslint-disable quotes */
import React, { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Row, Col, Card, message, Tag, Spin, Button } from "antd";
import { ReloadOutlined } from "@ant-design/icons";
import TableContainer from "../../../components/TableContainer";
import Heading from "../../../components/Heading";
import API from "../../../api";
import urls from "../../../api/urls";
import moment from "moment";
import { dateFormat_dmy } from "../../../utils";
import Smcs_Loader from "../../../assests/images/loader-new.gif";
import "./style.scss";

const { GET_PENDING_AWBS } = urls;

const PendingAwbs = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const cpId = searchParams.get("cp_id");

  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const getPendingAwbs = async (page = currentPage, limit = pageSize) => {
    try {
      setLoading(true);

      if (!cpId) {
        message.error("CP ID is required");
        return;
      }

      const response = await API.Api(
        `${GET_PENDING_AWBS}?cp_id=${cpId}&page=${page}&limit=${limit}`
      ).get();

      if (response?.status && response?.response?.data?.status === "success") {
        const data = response.response.data.data;
        setTableData(data.pendingAwbs || []);
        setTotal(data.totalCount || 0);
        setTotalPages(data.totalPages || 1);
      } else {
        message.error(
          response?.response?.data?.message || "Failed to fetch pending AWBs"
        );
        setTableData([]);
        setTotal(0);
        setTotalPages(1);
      }
    } catch (error) {
      message.error(error?.message || "Error fetching pending AWBs");
      setTableData([]);
      setTotal(0);
      setTotalPages(1);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (cpId) {
      getPendingAwbs();
    }
  }, [cpId, currentPage, pageSize]);

  const handlePageChange = (page, size) => {
    // Validate page number doesn't exceed total pages
    const validPage = Math.min(page, totalPages);
    setCurrentPage(validPage);
    if (size !== pageSize) {
      setPageSize(size);
      setCurrentPage(1); // Reset to first page when page size changes
    }
  };

  const handleRefresh = () => {
    getPendingAwbs(currentPage, pageSize);
  };

  const getStatusColor = (status) => {
    switch (status?.toUpperCase()) {
      case "OPEN":
        return "#FF9800";
      case "CLOSED":
        return "#4CAF50";
      case "PENDING":
        return "#2196F3";
      default:
        return "#808080";
    }
  };

  const getRuleIdDisplay = (ruleId) => {
    // Convert LOCK_NOT_BOOKED to "Lock Not Booked"
    if (!ruleId) return "N/A";
    return ruleId
      .replace(/_/g, " ")
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  const columns = [
    {
      title: "S.No",
      dataIndex: "sNo",
      key: "sNo",
      width: 70,
      align: "center",
      render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
    },
    {
      title: "AWB Number",
      dataIndex: "awbNumber",
      key: "awbNumber",
      width: 150,
      render: (text) => text,
    },
    {
      title: "Lock Rule",
      dataIndex: "ruleId",
      key: "ruleId",
      width: 180,
      render: (text) => getRuleIdDisplay(text),
    },
    {
      title: "Location",
      dataIndex: "hubAtEvent",
      key: "hubAtEvent",
      width: 160,
      render: (text) => text,
    },
    {
      title: "Received At",
      dataIndex: "receivedAt",
      key: "receivedAt",
      width: 160,
      render: (text) => {
        if (!text) return "N/A";
        return moment(text).format(dateFormat_dmy + " hh:mm A");
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: 100,
      align: "center",
      render: (text) => (
        <Tag
          color={getStatusColor(text)}
          key={text}
          style={{ fontWeight: "500" }}
        >
          {text || "N/A"}
        </Tag>
      ),
    },
  ];

  return (
    <Spin
      spinning={loading}
      indicator={
        <img src={Smcs_Loader} style={{ height: "100px", width: "100px" }} />
      }
    >
      <div className="pending-awbs-container p-1">
        <Heading title="Pending AWBs" navigateTo="/ho-operations-dashboard" />

        <Card
          title={
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
              }}
            >
              <div
                style={{ display: "flex", gap: "12px", alignItems: "center" }}
              >
                <span className="cp-id-badge">CP ID: {cpId}</span>
                <span className="total-awbs-badge">
                  Total Pending AWBs: {total}
                </span>
              </div>
              <Button
                type="default"
                icon={<ReloadOutlined />}
                onClick={handleRefresh}
                disabled={loading}
              >
                Refresh
              </Button>
            </div>
          }
          className="pending-awbs-card"
          style={{ marginTop: "24px" }}
        >
          <TableContainer
            loading={loading}
            columns={columns}
            dataSource={tableData}
            rowKey="awbNumber"
            pagination={{
              current: currentPage,
              pageSize: pageSize,
              total: total,
              showSizeChanger: true,
              pageSizeOptions: ["15", "30", "50", "100"],
              position: ["bottomRight"],
              onChange: handlePageChange,
              onShowSizeChange: handlePageChange,
              showQuickJumper: true,
            }}
          />
        </Card>
      </div>
    </Spin>
  );
};

export default PendingAwbs;
